// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portion-tab .portion-tree[data-v-cdb2f62a] {\n  height: 100%;\n  overflow: auto;\n}\n.theme--light.portion-tab[data-v-cdb2f62a] {\n  background-color: #f6f6f6;\n}\n.theme--dark.portion-tab[data-v-cdb2f62a] {\n  background-color: #273039;\n}", ""]);
// Exports
module.exports = exports;
